import { CRM_OBJECT_PIPELINE_SETTINGS } from './crmObjectPipelines/types';
import { CRM_BOARD_SETTINGS } from './crmObjectBoard/types';
import { CRM_TAGS_SETTINGS } from './crmTags/types';
import { CRM_INDEX_SETTINGS } from './crmIndexPage/types';
export const TEST_FAS = 'TEST_FAS';